<template>
    <form method="get" action="/search" autocomplete="off" class="HeroSearch">
        <input type="text" name="query" :placeholder="searchPlaceholder">
        <button>
            <svg class="search-icon" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd" stroke-width="1.5" transform="translate(1.6 1.6)"><path stroke-linecap="round" stroke="#FFFFFF" d="M12.8 12.8l-4-4"/><circle cx="5.2" cy="5.2" r="5.2"  stroke="#FFFFFF" /></g></svg>
        </button>
    </form>
</template>

<script>

export default {
    name: 'HeroSearch',
    props: {
        searchPlaceholder: {
            type: String,
            default: 'Search'
        }
    },
    data() {
        return {
            query: ''
        }
    }
}
</script>
<style lang="scss">
    .HeroSearch {
        background: rgba(255, 255, 255, 0.5);
        padding: 20px 28px;
        display: flex;
        align-items: center;

        @include media-query(tiny) {
            width: 100%;
        }
    }

    .HeroSearch input {
        border: 0;
        outline: 0;
        background: 0;
        color: #fff;
        font-family: "DIN", Helvetica, sans-serif;
        font-size: 18px;
        min-width: 280px;
        
        &::placeholder {
            color: #fff;
            opacity: 0.75;
        }

        @include media-query(tiny) {
            min-width: unset;
            width: 100%;
        }
    }

    .HeroSearch button {
        padding-left: 18px;

        .search-icon {
            width: 20px;
            height: 20px;
        }
    }
</style>
